import * as React from "react";
const SvgXmark = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 6L18 18M18 6L6 18", stroke: "#0B1370", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgXmark;
